import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)

let RouteList = [{
    path: '/',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
        title: '首页',
        keepAlive: false,
    },
    children: [{
        path: '/',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: true
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },
    {
        path: '/font_awesome',
        name: 'FontAwesome',
        meta: {
            title: 'FontAwesome 图标',
            keepAlive: false
        },
        component: resolve => require(['@/views/icon/FontAwesome.vue'], resolve),
    },
    {
        path: '/element_icon',
        name: 'ElementIcon',
        meta: {
            title: 'Element 图标',
            keepAlive: false
        },
        component: resolve => require(['@/views/icon/ElementIcon.vue'], resolve),
    },
    //个人资料
    Personal.index,
    // ===== 业务BEGIN  =====
    {
        path: '/',
        name: 'Home',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },
    {
        path: '/movie_orders',
        name: 'GoodsOrder',
        meta: {
            title: '影票订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/List.vue'], resolve),
    },
    {
        path: '/oil_orders',
        name: 'oilOrder',
        meta: {
            title: '油卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/oil_orders.vue'], resolve),
    },
    {
        path: '/tel_orders',
        name: 'telsOrder',
        meta: {
            title: '话费订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/tel_orders.vue'], resolve),
    },
    {
        path: '/goods_orders',
        name: 'goodsOrders',
        meta: {
            title: '电商订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/goods_orders.vue'], resolve),
    },
    {
        path: '/channel_account',
        name: 'ChannelAccount',
        meta: {
            title: '我的账户',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/Account.vue'], resolve),
    },
    {
        path: '/charge_success',
        name: 'charge_success',
        meta: {
            title: '支付成功',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/charge_success.vue'], resolve),
    },
    {
        path: '/channel_data',
        name: 'ChannelData',
        meta: {
            title: '渠道信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/Data.vue'], resolve),
    },
    {
        path: '/channel_develop',
        name: 'ChannelDevelop',
        meta: {
            title: '开发配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/Develop.vue'], resolve),
    },
    {
        path: '/priceTemplate',
        name: 'priceTemplate',
        meta: {
            title: '价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/priceTemplate.vue'], resolve),
    },
    {
        path: '/charge_orders',
        name: 'ChargeOrders',
        meta: {
            title: '充值订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/charge/Orders.vue'], resolve),
    },
    {
        path: '/goods',
        name: 'goods',
        meta: {
            title: '商品列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/goods/goods.vue'], resolve),
    },
    {
        path: '/jd_order',
        name: 'jd_order',
        meta: {
            title: '京东订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/jd_order.vue'], resolve),
    },
    ]
},
{
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
},
{
    path: '/*',
    name: 'NotFound',
    meta: {
        title: '404',
        keepAlive: true
    },
    components: {
        blank: resolve => require(['@/views/error/404.vue'], resolve),
    }
}
]

export default new Router({
    routes: RouteList
})